const TWITCH_CHANNEL_PREFIX = "ddh-twitch-party-";
const VIMEO_EVENT_PREFIX = "ddh-vimeo-party-";

export function getJitsiRoomName(options: {
    twitchChannel?: string;
    livestreamChannel?: {
        account: number;
        event: number;
    };
    vimeoEvent?: string;
}): string {
    const { twitchChannel, livestreamChannel, vimeoEvent } = options;
    if (twitchChannel !== undefined) {
        return `${TWITCH_CHANNEL_PREFIX}${twitchChannel}`;
    } else if (livestreamChannel !== undefined) {
        return `livestream-with-${livestreamChannel.account}-event-${livestreamChannel.event}`;
    } else if (vimeoEvent !== undefined) {
        return `${VIMEO_EVENT_PREFIX}${vimeoEvent}`;
    }

    // TODO
    return "virtual-club-unimplemented";
}

export function roomNameToDisplayName(roomName: string) {
    if (roomName.startsWith(TWITCH_CHANNEL_PREFIX)) {
        return `digital dance hall: ${roomName.substr(TWITCH_CHANNEL_PREFIX.length)}`;
    } else if (roomName.startsWith(VIMEO_EVENT_PREFIX)) {
        return `digital dance hall: ${roomName.substr(VIMEO_EVENT_PREFIX.length)}`;
    }

    return "digital dance hall";
}

/** Invite URL (without the origin) */
export function getInvitationPathForRoom(roomName: string) {
    if (roomName.startsWith(TWITCH_CHANNEL_PREFIX)) {
        return `stream?twitchChannel=${roomName.substr(TWITCH_CHANNEL_PREFIX.length)}`;
    } else if (roomName.startsWith(VIMEO_EVENT_PREFIX)) {
        return `stream?vimeoEvent=${roomName.substr(VIMEO_EVENT_PREFIX.length)}`;
    }

    return `?room=${roomName}`;
}
